export enum EnuAppOps {
  app_user = "app_user", //  string
  app_volume = "app_volume", //  string
  app_path = "app_path", //  string

  app_start = "app_start", //  timestamp
  app_close = "app_close", //  timestamp
  app_error = "app_error", //  string
  //
  spv_msg_start = "spv_msg_start", //  string
  spv_msg_end = "spv_msg_end", //  string
  spv_msg_error = "spv_msg_error", //  string
  // abort
  spv_msg_abort = "spv_msg_abort", //  string
  // download attahment
  spv_msg_download = "spv_msg_download", //  string
  // unpack attachment
  spv_msg_unpack = "spv_msg_unpack", //  string
  // parse attachment
  spv_msg_parse = "spv_msg_parse", //  string
  // writeout xml contractor data
  spv_msg_contracordata = "spv_msg_contracordata", //  string
  // save archived attachment as blob
  spv_msg_dataraw = "spv_msg_dataraw", //  string
  // writeout archive content as fs record
  spv_msg_content = "spv_msg_content", //  string
  // update current state.
  spv_msg_setstate = "spv_msg_setstate", //  string
  // insider operation
  collection_start_editing = "collection_start_editing", //  string
  collection_end_editing = "collection_end_editing", //  string
  spvlist_mark_start = "spvlist_mark_start", //  string
  spvlist_mark_end = "spvlist_mark_end", //  string
}

export type TApplicationLog = {
  operation: keyof typeof EnuAppOps;
  value: string;
  timestamp: number;
};

type LogRecordKey<T> = `${number}-${keyof typeof EnuAppOps}`;

export type LogRecord = Record<LogRecordKey<TApplicationLog>, TApplicationLog>;
// how do I type  a record with key formed of <`{TApplicationLog["timestamp"]-TApplicationLog["operation"]}` TApplicationLog>
